interface MetricsData {
    totalApprovedRequisitions: number;
    totalPendingRequisitions: number;
    totalRejectedRequisitions: number;
    totalRequisitions: number;
}


interface MetricsProps {
    metrics: MetricsData;
}

const RequisitionCard: React.FC<MetricsProps> = ({ metrics }) => {
    return(
        <div  className="my-7">
            <div className="flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
                <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                        Total Requisitions
                    </p>
                    <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
                        {metrics?.totalRequisitions || 0}
                    </h1>
                </section>
                <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                        Approved Requisitions
                    </p>
                    <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
                        {metrics?.totalApprovedRequisitions || 0}
                    </h1>
                </section>
                <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                        Pending Requisitions
                    </p>
                    <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
                        {metrics?.totalPendingRequisitions || 0}
                    </h1>
                </section>
                <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
                    <p className="font-bold text-[14px] text-[#475467]">
                        Rejected Requisition
                    </p>
                    <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
                        {metrics?.totalRejectedRequisitions || 0}
                    </h1>
                </section>


            </div>

        </div>
    )
}

export default RequisitionCard;